import { render, staticRenderFns } from "./ItemQuiz.vue?vue&type=template&id=3714c7d5&"
import script from "./ItemQuiz.vue?vue&type=script&lang=js&"
export * from "./ItemQuiz.vue?vue&type=script&lang=js&"
import style0 from "./ItemQuiz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports